<script>
import { store } from '../state/store'
import router from '../router/index'
import Modal from '@components/modal.vue'
import FooterComponent from '@components/footer.vue'
import SystemTestService from '@services/business/system-test.service'
import storageService from '@services/storage.service'
import AuthService from '@services/auth.service'
import ErrorAlert from '@components/error-alert.vue'
import { roles, phoneNumbers } from '../models/enums'

export default {
  components: { Modal, FooterComponent, ErrorAlert },
  props: {
    status: {
      type: String,
      default: '',
    },
    customerName: {
      type: String,
      default: '',
    },
    jobNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      state: store.state,
      now: Date.now(),
      toolsActive: false,
      shouldTwoWayModalBeShown: false,
      shouldRescheduleModalBeShown: false,
      isLoading: false,
      phone: '',
      isTwoWayTestDisabled: this.hasTwoWayTestBeenStarted(),
    }
  },
  computed: {
    twoWayTestAvailable: function() {
      return (
        this.state.currentJob.jobEmployeeStatus === 'O' ||
        storageService.isInstallFlowWithCSNumber()
      )
    },
    systemTestStatus: function() {
      return this.state.systemTest.onTest ? 'ON TEST' : ''
    },
    systemTestRemaining: function() {
      if (
        this.state.systemTest.onTest &&
        this.state.systemTest.localExpireDate
      ) {
        return this.convertMS(
          new Date(this.state.systemTest.localExpireDate).getTime() -
            new Date(this.now).getTime()
        )
      } else {
        return ''
      }
    },
    jobEmployeeStatus: function() {
      if (this.state.currentJob.jobEmployeeStatus === 'A') {
        return 'Assigned'
      } else if (this.state.currentJob.jobEmployeeStatus === 'E') {
        return 'En Route'
      } else if (this.state.currentJob.jobEmployeeStatus === 'O') {
        return 'On Site'
      } else if (this.state.currentJob.jobEmployeeStatus === 'C') {
        return 'Complete'
      } else {
        return ''
      }
    },
  },
  created() {
    var self = this
    setInterval(function() {
      self.now = Date.now()
    }, 30000)
  },
  methods: {
    hasTwoWayTestBeenStarted() {
      return !!storageService.getTwoWayTestState()
    },
    getPhoneNumberForTechRole() {
      if (AuthService.HasRole(roles.BRINKS_TECH)) {
        this.phone = phoneNumbers.FIELD_TECH_DISPATCH
      } else if (
        AuthService.HasRole(roles.TECH_APP_ADMIN) ||
        AuthService.HasRole(roles.DEALER_TECH)
      ) {
        this.phone = phoneNumbers.SCHEDULING
      } else {
        this.phone = phoneNumbers.GENERAL
      }
    },
    startTwoWayTest() {
      storageService.saveTwoWayTestState()
    },
    toolsActiveChanged() {
      this.toolsActive = !this.toolsActive
    },
    openTwoWayTestModal() {
      this.shouldTwoWayModalBeShown = true
    },
    openRescheduleJobModal() {
      this.getPhoneNumberForTechRole()
      this.shouldRescheduleModalBeShown = true
    },
    closeTwoWayModal() {
      this.shouldTwoWayModalBeShown = false
    },
    closeRescheduleModal() {
      this.shouldRescheduleModalBeShown = false
    },
    async prepareForTwoWayTest() {
      this.isLoading = true
      SystemTestService.prepareSiteForTwoWayTest()
        .then(() => {
          this.isLoading = false
          this.startTwoWayTest()
          this.isTwoWayTestDisabled = true
          store.putSystemOffTest()
          this.closeTwoWayModal()
        })
        .catch((err) => {
          this.isLoading = false
          console.error(err)
          store.presentErrorAlert('Unable to prepare site for Two-Way Test.')
        })
    },
    goToJobLookup() {
      router.push('/')
    },
    convertMS(ms) {
      var d, h, m, s
      s = Math.floor(ms / 1000)
      m = Math.floor(s / 60)
      s = s % 60
      h = Math.floor(m / 60)
      m = m % 60
      d = Math.floor(h / 24)
      h = h % 24
      h += d * 24
      return h + 'h ' + m + 'm'
    },
    goToSiteDetails() {
      router.push('site-details')
    },
  },
}
</script>

<template>
  <div :class="$style.tech_header">
    <Modal v-if="shouldTwoWayModalBeShown" @close="closeTwoWayModal">
      <div slot="header">
        <h3 :class="$style.modal_title">CONFIRM 2-WAY TEST</h3>
      </div>
      <div slot="body">
        <div v-show="isLoading" :class="$style.modal_spinner_container">
          <div class="spinner"></div>
        </div>
        <div v-show="!isLoading">
          <ErrorAlert></ErrorAlert>
          <p
            >Are you sure that you want to do a 2-way test? If the system is on
            test, doing so will <b>take the system off test.</b></p
          >
        </div>
      </div>
      <FooterComponent
        slot="footer"
        secondary-btn-type="link"
        secondary-btn-text="Cancel"
        :secondary-btn-callback="closeTwoWayModal"
        primary-btn-text="CONFIRM"
        :primary-btn-callback="prepareForTwoWayTest"
        :class="$style.footer_container_override"
        :primary-btn-disable-state="isLoading"
        primary-btn-id="btn-two-way-test"
      ></FooterComponent>
    </Modal>
    <Modal v-if="shouldRescheduleModalBeShown" @close="closeRescheduleModal">
      <div slot="header">
        <h3 :class="$style.modal_title">RESCHEDULE JOB</h3>
      </div>
      <div slot="body">
        <div v-show="isLoading" :class="$style.modal_spinner_container">
          <div class="spinner"></div>
        </div>
        <div v-show="!isLoading">
          <div :class="$style.dealer_services_container">
            <div :class="$style.dealer_services_label"
              >Call Dealer Services to Reschedule</div
            >
            <div class="py-2"
              ><a
                :class="$style.dealer_services_number"
                class="text-primary"
                :href="'tel:' + phone"
                >{{ phone }}</a
              ></div
            >
          </div>
        </div>
      </div>
      <FooterComponent
        slot="footer"
        secondary-btn-type="link"
        secondary-btn-text="Cancel"
        :secondary-btn-callback="closeRescheduleModal"
        primary-btn-text="JOB LOOKUP"
        :primary-btn-callback="goToJobLookup"
        :class="$style.footer_container_override"
        :primary-btn-disable-state="isLoading"
        class="reschedule-modal"
      ></FooterComponent>
    </Modal>
    <div class="row" :class="$style.tech_header_parent">
      <div class="col-7" :class="$style.job_info">
        <div v-if="jobEmployeeStatus" :class="$style.job_status">
          <label>{{ jobEmployeeStatus }}</label>
        </div>
        <button
          v-if="state.site.siteName || state.currentJob.jobNumber"
          id="link-header-site-details"
          class="btn-link text-white text-left"
          :class="$style.customer_info"
          @click="goToSiteDetails"
        >
          {{ state.site.siteName }}
        </button>
      </div>
      <div class="col-5" :class="$style.system_test_container">
        <div
          v-if="systemTestStatus"
          class="text-right text-white font-weight-bold"
          :class="$style.system_test"
        >
          <div>
            <div>{{ systemTestStatus }}</div>
            <div>{{ systemTestRemaining }}</div>
          </div>
        </div>
        <div v-popover:tools :class="$style.tools_button">
          <div class="tools-border" :class="{ 'tools-active': toolsActive }">
            <svg class="icon" :class="$style.tools_icon">
              <use
                xlink:href="../assets/images/brinkshome_icons.svg#icon-tools"
              ></use></svg></div
          ><popover
            name="tools"
            :pointer="false"
            :width="250"
            @show="toolsActiveChanged"
            @hide="toolsActiveChanged"
          >
            <div class="tool_header">ADDITIONAL TOOLS</div>
            <div class="links">
              <button class="btn btn-link" @click="openRescheduleJobModal"
                >Reschedule</button
              >
              <button
                v-if="twoWayTestAvailable"
                class="btn btn-link"
                :disabled="isTwoWayTestDisabled"
                @click="openTwoWayTestModal"
                >Two-Way Test</button
              >
            </div>
          </popover>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.tools-active {
  border-color: #24d1bc !important;
}

.tools-border {
  border-color: transparent;
  border-style: solid;
  border-width: 2px;
}

div[data-popover='tools'] > .tool_header {
  padding: 0.5em;
  font-weight: bold;
  color: white;
  text-align: center;
  background-color: #0033a0;
  cursor: default;
}

div[data-popover='tools'] > .links button {
  text-decoration: underline;
}

div[data-popover='tools'] > .links button:hover {
  text-decoration: underline;
  font-weight: 900;
  color: #eee;
}

div[data-popover='tools'] > .links {
  padding: 1em;
}

div[data-popover='tools'] {
  top: 4em !important;
  right: 0 !important;
  left: auto !important;
  padding: 0 !important;
  color: #0033a0;
  text-align: left;
  background: #c0c0c0;
  border-radius: 0 !important;
}

.reschedule-modal button {
  margin: 0;
  width: 49%;
}

.reschedule-modal .btn + .btn {
  margin-left: 0;
}
</style>

<style lang="scss" module scoped>
@import '@design';
.tools_button:hover {
  cursor: pointer;
}

.tools_button:focus {
  border-color: $color_teal;
}

.tools_icon {
  width: 3em;
  height: 3em;
}

.tech_header_parent {
  width: 100%;
  margin: 0;
}

.job_info {
  padding: 0;
}

.job_status label {
  font-size: 25px !important;
  color: $color-teal;
  text-transform: initial;
}

.tech_header {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: $height-status-bar;
  padding: 0.75em;
  background-color: $color-header;
}

.tech_header label {
  margin-bottom: 0;
}

.tech_header h4 {
  margin-bottom: 0;
}

.system_test {
  padding: 0.25rem;
  font-size: large;
}

.system_test_container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  color: $color-white;
}

.customer_info {
  padding: 0;
  margin-left: 0.25rem;
  font-weight: normal;
  text-decoration: underline;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
}

.close_button {
  float: right;
  background-color: transparent;
  border: 0;
  color: $color-text-secondary;
  cursor: pointer;
  font-size: 1.5em;
}

.close_button:hover {
  color: $color-text-primary;
}

.modal_title {
  color: $color-text-primary;
  font-weight: 900;
  margin-bottom: 0;
}

.footer_container_override {
  position: relative;
  background-color: $color-body-bg;
}

.modal_spinner_container {
  margin: 4em;
}

.dealer_services_container {
  margin: 1em;
  text-align: center;
}

.dealer_services_label {
  font-weight: $heading-font-weight;
}

.dealer_services_number {
  font-size: 1.5em;
}
</style>
